import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollCalculatedExpression  {
    _originalTypeClassName = "zERP.BO.PayrollCalculatedExpression";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollCalculatedExpression.translate = translateService;
}
this.lstPayrollVariable = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Module = null;
this.DefinitionLevel = null;
this.Code = null;
this.Code_ = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Module:any;
DefinitionLevel:any;
Code:any;
Code_:any;
Data:any;
lstPayrollVariable:any;
static setData = ($this, value) => {
var oldValue = $this.Data;
$this.Data = value;
if (value != null) {
}
}
static setlstPayrollVariable = ($this, items) => {
                if (items == null) items = [];
                if ($this.lstPayrollVariable == null) $this.lstPayrollVariable = [];

                const copyItems = Common.cloneObject(items);

                while ($this.lstPayrollVariable.length > 0) {
                    Domain.PayrollCalculatedExpression.removelstPayrollVariable($this, $this.lstPayrollVariable[0]);
                }

                Domain.PayrollCalculatedExpression.addManylstPayrollVariable($this, copyItems);
            }
static addManylstPayrollVariable = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollCalculatedExpression.addlstPayrollVariable($this, items[i]);
                }
            }
static addlstPayrollVariable = ($this, item) => {
                if ($this.lstPayrollVariable == null) $this.lstPayrollVariable = [];
                if (item == null || $this.lstPayrollVariable.indexOf(item) > -1) return;
                $this.lstPayrollVariable.push(item);
}
static addRangelstPayrollVariable = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollCalculatedExpression.addlstPayrollVariable($this, item));
            }
static removelstPayrollVariable = ($this, item) => {
                if ($this == null || $this.lstPayrollVariable == null || $this.lstPayrollVariable.indexOf(item) === -1) return;
                var _index = $this.lstPayrollVariable.indexOf(item);
                $this.lstPayrollVariable.splice(_index, 1);
}
static clearlstPayrollVariable = ($this) => { $this.lstPayrollVariable = null; }

static GetClassName(): any{return "PayrollCalCulatedExpression";
}
static GetUsedVariables($this: any, variables: any): any{let used = [];
let code = $this?.Data?.Expression?.trim();
for (let _ivariable = 0; _ivariable < (variables == null ? 0 : variables.length); _ivariable++) {let variable = variables[_ivariable];if ((new RegExp("\\b" + variable?.Code + "\\b").test(code))) {used?.add(variable?.Code);}}
return used;
}
static IsReadonly($this: any): any{return $this?.DefinitionLevel == Domain.EntityDefinitionLevel.Systemic || $this?.DefinitionLevel == Domain.EntityDefinitionLevel.Library;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}